import { LocaleEnum } from '../../../models/locale';
import { GameData } from '../../data';

export function languagesFrEnMigrator(game: GameData): GameData {
  if (game.config.local === 'fr') {
    game.config.local = LocaleEnum.FR;
  }
  if (game.config.local === 'en') {
    game.config.local = LocaleEnum.EN;
  }
  return game;
}
